import React from "react";
import styles from "./FiltersList.module.scss";
import { switches as requestSwitches } from "../../ResultsList.utils";
import { switches, flattenedData } from "./FiltersList.utils";
import { ReactComponent as CloseIcon } from '../../../../../assets/icons/close.svg'
import { useResultListContext } from "common/contexts/ResultListContext";
import { useLocation, useNavigate } from 'react-router-dom';
import getSymbolFromCurrency from "currency-symbol-map";

const FiltersList = ({ handleDurationSelection, onWorkspaceHandler, fetchData }: any) => {
  const {
    // activeFilters,
    setActiveFilters,
    durationOptions,
    workspaceType,
    setWorkspaceType,
    currentLocation,
    currentDuration,
    budgetValues,
    budgetRange,
    setBudgetValues,
    sortBy,
    setAmenitiesPayload,
  } = useResultListContext();

  const location = useLocation();
  const navigate = useNavigate();
  // @ts-ignore
  const currentCurrency = getSymbolFromCurrency(window?.hydrateJSON?.currencyCode) || getSymbolFromCurrency('EUR');

  const selectedValues = [];
  const searchParams = new URLSearchParams(location.search);
  const amenitiesFilter = searchParams.get('amenities')?.replace(/^,+/g, '').replace(/,+/g, ',').replace(/,$/g, '').replace(/undefined|^undefined,|,undefined$|,undefined,/g, '').replace(/NaN|NaN,|,NaN$|,NaN,/g, '') || '';
  if (amenitiesFilter.length > 0) {
    const keys = amenitiesFilter.split(',');
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      selectedValues.push(flattenedData[key]);
    }
  }
  const filteredDurationOptions = durationOptions.filter((option) => option.isActive).map((option) => option.title);
  const filteredWorkspaceType = Object.keys(workspaceType).filter((key) => workspaceType[key]).map((key) => switches[key as keyof typeof switches]);
  
  const showBudgetFilter = budgetValues[0] !== budgetRange[0] || budgetValues[1] !== budgetRange[1];
  const budgetFilter = `${currentCurrency || ''} ${Math.round(budgetValues[0])} - ${currentCurrency || ''} ${Math.round(budgetValues[1])}`;
  
  const combinedFilters = [...selectedValues, ...filteredDurationOptions, ...filteredWorkspaceType];
  if (showBudgetFilter) combinedFilters.push(budgetFilter);

  const removeFilter = (name: string) => {
    if (name === "Daily" || name === "Monthly" || name === "Annually") {
      const idx = name === "Annually" ? 2 : name === "Monthly" ? 1 : 0;
      handleDurationSelection(idx);
    } else if (
      name == "Coworking Space" ||
      name == "Private Office" ||
      name == "Virtual Office" ||
      name == "Airport Lounge"
    ) {
      const trueKeys = Object.keys(workspaceType).filter((key) => workspaceType[key]);
      const resultValues = trueKeys.map((key) => requestSwitches[key as keyof typeof requestSwitches]);
      const switchKey = Object.keys(switches).filter((key) => switches[key] === name)[0] as keyof typeof requestSwitches;
      const valueToRemove = requestSwitches[switchKey];
      const filteredResultValues = resultValues.filter((value) => value !== valueToRemove);
      setWorkspaceType((prev) => ({ ...prev, [switchKey]: false }));
      onWorkspaceHandler(filteredResultValues);
    } else if (name.includes(currentCurrency || '€')) {
      setBudgetValues([budgetRange[0], budgetRange[1]]);
      fetchData(
        currentLocation.lat,
        currentLocation.lng,
        currentLocation.rad,
        10,
        0,
        // @ts-ignore
        Object.entries(workspaceType).filter((el) => el[1] == true).map(item => requestSwitches[item[0]]),
        `&amenities=${amenitiesFilter}`,
        currentDuration,
        [budgetRange[0], budgetRange[1]],
        sortBy,
      );
    } else {
      let keyToRemove: string = "";
      for (const [key, value] of Object.entries(flattenedData)) {
        if (value === name) {
          keyToRemove = key;
          break;
        }
      }
      setActiveFilters((prev: any) => {
        const updatedFilters = { ...prev };
        updatedFilters[keyToRemove] = false;

        const activeFilterKeys = Object.entries(updatedFilters).filter(([, value]) => value === true).map(([key]) => key).join(",");
        const request = `&amenities=${activeFilterKeys}`;
        
        fetchData(
          currentLocation.lat,
          currentLocation.lng,
          currentLocation.rad,
          10,
          0,
          // @ts-ignore
          Object.entries(workspaceType).filter((el) => el[1] == true).map(item => requestSwitches[item[0]]),
          request,
          currentDuration,
          budgetValues,
          sortBy,
        );
        return updatedFilters;
      });

      
    }
  };
  
  const clearFilters = () => {
    setActiveFilters({});
    handleDurationSelection(0, true);
    setWorkspaceType({});
    // @ts-ignore
    setBudgetValues([0, Number(window?.hydrateJSON?.initial_data.counts.prices.highest_price) || budgetRange[1]])
    onWorkspaceHandler([], true);
    setAmenitiesPayload('');

    const pathname = location.pathname;
    navigate(`${pathname}`);
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {combinedFilters.map((filter, index) => {
          if (filter?.length > 0) {
            return <div className={styles.filter_option} key={index}>
              {filter}
              <button
                className={styles.closeButton}
                onClick={() => {
                  removeFilter(filter);
                }}
                type="button"
              >
                <CloseIcon className={styles.closeIcon} />
              </button>
            </div>
            }
            return;
        })}
        {combinedFilters.length > 0 && (
        <button className={styles.clear} type="button" onClick={clearFilters}>
          Clear Filters
        </button>
        )}
      </div>
    </div>
  );
};

export default FiltersList;
